import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { fromEvent, of, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-table-filter-select',
  templateUrl: './table-filter-select.component.html',
  styleUrls: ['./table-filter-select.component.scss']
})
export class TableFilterSelectComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() name: string = '';
  @Input() selectedValue?: any;
  @Output() selectValue = new EventEmitter<any>();

  @ViewChild('control') control?: ElementRef<HTMLSelectElement>;
  unsubscribe$ = new Subject();

  ngAfterViewInit(): void {
    const control$ = !!this.control?.nativeElement ? fromEvent(this.control?.nativeElement, 'change') : of();
    control$.pipe(takeUntil(this.unsubscribe$)).subscribe((val: any) => this.selectValue.emit(val.target.value));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['selectedValue'] && changes['selectedValue'].currentValue === undefined) {
      (this.control?.nativeElement || { value: '' }).value = '-1';
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }
}
